import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ReactComponent as StoreSVG } from 'icons/store.svg';
import { ReactComponent as UserCircleSVG } from 'icons/user-circle.svg';
import { ReactComponent as BookOpenSVG } from 'icons/book-open.svg';
import { ReactComponent as SignoutSVG } from 'icons/signout.svg';
import { ReactComponent as CreditCardSVG } from 'icons/credit-card.svg';
import { ReactComponent as CameraSVG } from 'icons/camera.svg';
import { userShape } from 'helpers/shared_types';

const DoctorDropdown = ({ user, onSignOut }) => {
  if (user.type === 'non-sleep') {
    return (
      <div className="th-nav-menu-dropdown">
        <ul className="dropdown-menu dropdown-triangle-top">
          <li>
            <Link to="/profile" className="dropdown-item">
              <UserCircleSVG />
              Profile
            </Link>
          </li>
          <li className="divider" />
          <li>
            <a
              href="https://sleepdoctor.me/"
              className="dropdown-item"
              target="_blank"
              rel="noopener noreferrer"
            >
              <StoreSVG /> About SleepDoctor
            </a>
          </li>
          <li>
            <a
              className="dropdown-item"
              target="_blank"
              href="https://sleepdoctor.me/blog"
              rel="noopener noreferrer"
            >
              <BookOpenSVG />
              SleepDoctor Blog
            </a>
          </li>
          <li className="divider" />
          <li>
            <button
              className="dropdown-item"
              data-cy="sign-out"
              onClick={onSignOut}
            >
              <SignoutSVG />
              Sign out
            </button>
          </li>
        </ul>
      </div>
    );
  }
  return (
    <div className="th-nav-menu-dropdown">
      <ul className="dropdown-menu dropdown-triangle-top">
        <li>
          <Link to="/profile" className="dropdown-item">
            <UserCircleSVG />
            Profile
          </Link>
        </li>
        <li className="divider" />
        <li>
          <a
            href={user?.teleconsultationRoomUrl}
            className="dropdown-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <CameraSVG /> Teleconsultation room
          </a>
        </li>
        <li>
          <a
            className="dropdown-item"
            target="_blank"
            href={user?.stripeUrl}
            rel="noopener noreferrer"
          >
            <CreditCardSVG />
            Stripe link
          </a>
        </li>
        <li className="divider" />
        <li>
          <a
            href="https://sleepdoctor.me/"
            className="dropdown-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <StoreSVG /> About SleepDoctor
          </a>
        </li>
        <li>
          <a
            className="dropdown-item"
            target="_blank"
            href="https://sleepdoctor.me/blog"
            rel="noopener noreferrer"
          >
            <BookOpenSVG />
            SleepDoctor Blog
          </a>
        </li>
        <li className="divider" />
        <li>
          <button
            className="dropdown-item"
            data-cy="sign-out"
            onClick={onSignOut}
          >
            <SignoutSVG />
            Sign out
          </button>
        </li>
      </ul>
    </div>
  );
};

DoctorDropdown.propTypes = {
  user: userShape,
  onSignOut: PropTypes.func.isRequired,
};

export default DoctorDropdown;
